import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Flex } from '@radix-ui/themes';
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type';
import { MenuButtonsList } from '../../../components/menuButton/MenuButtonsList';
import { MenuButtonConfig } from '../../../components/menuButton/MenuButton';
import { getTranslationByPath } from '../../../utils/translations';
import useLanguage from '../../../contexts/language/LanguageContext';
import { Footer } from '../../../layout/footer/Footer';
import { MainContent } from '../../../layout/content/MainContent';
import { setSelectedPage } from '../../../store/slices/app/appSlice';


export type SignpostTemplateType = {
  label: string
  textAlign: string
  buttons: {
    label: TranslationPath
    description: TranslationPath
    transitionUrl: TransitionUrl
    image: string
  }[]
}

type Props = {
  page: Page<SignpostTemplateType>
}

export const SignpostTemplate = (props: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const language = useLanguage()

  return (
    <div>
      <MainContent>
        <Flex direction="column" gap="1" width="100%" className="items-center">
          <Box maxWidth="500px" className="w-full flex flex-col items-center text-center">

            <div className="text-center mb-10">
              {getTranslationByPath(language.translations, props.page.data.label)}
            </div>
            <MenuButtonsList buttons={props.page.data.buttons.map(b => ({
              ...b,
              label: getTranslationByPath(language.translations, b.label),
              description: getTranslationByPath(language.translations, b.description),
              textAlign: props.page.data.textAlign,
              onClick: () => {
                dispatch(setSelectedPage(b.transitionUrl))
              },
            })) as MenuButtonConfig[]} />
          </Box>
        </Flex>
      </MainContent>
      <Footer backUrl={props.page.footer?.back} />
    </div>)
}
